import { render, staticRenderFns } from "./VerifyPhoto.vue?vue&type=template&id=bf04eab2&scoped=true&"
import script from "./VerifyPhoto.vue?vue&type=script&lang=ts&"
export * from "./VerifyPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyPhoto.vue?vue&type=style&index=0&id=bf04eab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf04eab2",
  null
  
)

export default component.exports